export default {
    pageHeaderMysteryParcel: 'pageHeaderMysteryParcel',
    pageParcel: 'pageParcel',
    pageRules: 'pageRules',
    titleYourStatus: 'titleYourStatus',
    titleAwards: 'titleAwards',
    titlePrizes: 'titlePrizes',
    titleMyPrizes: 'titleMyPrizes',
    titleLatestWinners: 'titleLatestWinners',
    titleIncludedGames: 'titleIncludedGames',
    buttonJoined: 'buttonJoined',
    buttonCompleted: 'buttonCompleted',
    buttonFinished: 'buttonFinished',
    buttonJoin: 'joinMysteryParcel',
    buttonHowToPlay: 'buttonHowToPlay',
    buttonLeaveParcel: 'buttonLeaveParcel',
    headerAwardsPrize: 'headerAwardsPrize',
    headerAwardsPrizesAwarded: 'headerAwardsPrizesAwarded',
    headerAwardsPrizesRemaining: 'headerAwardsPrizesRemaining',
    headerLastWinnersNickname: 'headerLastWinnersNickname',
    headerLastWinnersPrize: 'headerLastWinnersPrize',
    headerLastWinnersTime: 'headerLastWinnersTime',
    statusEligible: 'statusEligible',
    statusNotEligible: 'statusNotEligible',
    statusJoined: 'statusJoined',
    statusNotJoined: 'statusNotJoined',
    statusCompleted: 'statusCompleted',
    statusFinished: 'statusFinished',
    statusEligibleDescription: 'statusEligibleDescription',
    statusNotEligibleDescription: 'statusNotEligibleDescription',
    statusJoinedDescription: 'statusJoinedDescription',
    statusNotJoinedDescription: 'statusNotJoinedDescription',
    statusCompletedDescription: 'statusCompletedDescription',
    statusYouHaveTheParcel: 'statusYouHaveTheParcel',
    statusYouHaveTheParcelDescription: 'statusYouHaveTheParcelDescription',
    timerEndsIn: 'timerEndsIn',
    empty: 'empty',
    timerHhMmSs: 'timer.hh_mm_ss',
    timerHHhMMmSSs: 'timer.HHh_MMm_SSs',
    timerDdHhMmSs: 'timer.dd_hh_mm_ss',
    termsAndConditions: 'termsAndConditions',
    promotionFinished: 'promotionFinished',
    loadMore: 'loadMore',
    promotionNotAvailable: 'promotionNotAvailable',
    ok: 'ok'
};
